export function getDateHS (dateStr) {
  console.log(dateStr)
  let date = new Date(dateStr.replace(/-/g, '/'));
  let y = date.getFullYear();
  let m = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
  let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  let s = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  return `${y}-${m}-${d} ${h}:${s}`
}
